import React, { useState, useEffect, useRef } from "react";
import { useTranslate } from "react-admin";
import "./DriverLogField.css";
import { InlineEditor } from "./InlineEditor";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import ReactDOMServer from "react-dom/server";

interface Props {
  label: string;
  value: any;
  editable?: boolean;
  className?: string;
  render?: JSX.Element | null;
  textFieldProps?: any;
  onSave?: (value: string) => Promise<void>;
  insertOnly?: boolean;
}

export const DriverLogField = ({
  editable,
  label,
  className,
  render,
  textFieldProps = {},
  onSave,
  value,
  insertOnly,
}: Props) => {
  const translate = useTranslate();
  const [editing, setEditing] = useState<boolean>(false);
  const computedClassName = className
    ? `${className} driver-log-field-container`
    : "driver-log-field-container";

  const renderRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!renderRef.current) {
      return;
    }

    if (render) {
      const markup = ReactDOMServer.renderToStaticMarkup(render);
      if (!markup.trim()) {
        renderRef.current.innerHTML = `(${translate(
          "resources.common.labels.notSet",
          { _: "not set" }
        ).toLocaleLowerCase()})`;
      }
      return;
    }

    if (!value) {
      renderRef.current.innerHTML = `(${translate(
        "resources.common.labels.notSet",
        { _: "not set" }
      ).toLocaleLowerCase()})`;
    }
  });

  return (
    <div className={computedClassName}>
      <strong>{translate(label, { _: label })}:</strong>
      {editing ? (
        <InlineEditor
          onSave={onSave}
          textFieldProps={textFieldProps}
          initialValue={!insertOnly ? value : undefined}
          onClose={() => setEditing(false)}
        />
      ) : (
        <div className="driver-log-field">
          <div ref={renderRef}>{render ?? value}</div>
          {editable && (
            <IconButton size="small" onClick={() => setEditing(true)}>
              <EditIcon />
            </IconButton>
          )}
        </div>
      )}
    </div>
  );
};
